var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-20 border-r16 shadow-1 bg-white mt-20"},[_c('div',{attrs:{"id":"myChartMap"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }